var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefitNoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF3C5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73964 7.73964C8.05916 7.42012 8.5772 7.42012 8.89672 7.73964L12 10.8429L15.1033 7.73964C15.4228 7.42012 15.9408 7.42012 16.2604 7.73964C16.5799 8.05916 16.5799 8.5772 16.2604 8.89672L13.1571 12L16.2604 15.1033C16.5799 15.4228 16.5799 15.9408 16.2604 16.2604C15.9408 16.5799 15.4228 16.5799 15.1033 16.2604L12 13.1571L8.89672 16.2604C8.5772 16.5799 8.05916 16.5799 7.73964 16.2604C7.42012 15.9408 7.42012 15.4228 7.73964 15.1033L10.8429 12L7.73964 8.89672C7.42012 8.5772 7.42012 8.05916 7.73964 7.73964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitNoCheck);
export default __webpack_public_path__ + "static/media/benefitNoCheck.b02bed293d2c343d0e1ff39bed687212.svg";
export { ForwardRef as ReactComponent };